import {Component} from '@angular/core';
import {AlertController, LoadingController, NavController, NavParams} from 'ionic-angular';
import {WorkReportProvider} from "../../providers/work-report/work-report";
import {SaleOrderProvider} from "../../providers/sale-order/sale-order";
import {WorkReportEditPartPage} from "../work-report-edit-part/work-report-edit-part";
import {ValidationProvider} from "../../providers/validation/validation";
import {ToastProvider} from "../../providers/toast/toast";

/**
 * Generated class for the WorkReportPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-work-report',
  templateUrl: 'work-report.html',
})
export class WorkReportPage {

  salesOrder: any;
  workReportName: any;
  workReports: any = [];
  isWorkReportDeleteable: any = false;

  workReport: any = {
    date_work: null,
    from_time: null,
    to_time: null,
    start_break_time1: null,
    end_break_time1: null,
    start_break_time2: null,
    end_break_time2: null,
    km: 0,
    end_km: 0,
    total_km: 0,
    start_travel_time1: null,
    end_travel_time1: null,
    start_travel_time2: null,
    end_travel_time2: null,
    carplate_private: null,
    carplate_company: null,
    teile_markiert: null,
    remarks: "",
    farbe: null,
    wo: null
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private loadingCtrl: LoadingController,
    private workReportProvider: WorkReportProvider,
    private salesOrderProvider: SaleOrderProvider,
    private validation: ValidationProvider,
    private toast: ToastProvider,
    public alertController: AlertController
  ) {
    this.salesOrder = this.navParams.get('salesOrder');
    this.workReportName = this.navParams.get('workReportName');
    this.workReports = this.navParams.get('workReports');

    if (!this.workReportName)
      this.workReportName = 'WR39866';

  }

  async ionViewDidEnter() {
    let loading = this.loadingCtrl.create({content: "Arbeitsbericht wird geladen, bitte warten ..."});
    loading.present();

    if (!this.salesOrder) {
      this.salesOrder = await this.salesOrderProvider.get('A000368');
      this.workReports = await this.workReportProvider.getMyWorkReportsForSaleOrder(this.salesOrder.name);
    }

    this.workReport = await this.workReportProvider.get(this.workReportName);

    this.workReport.from_time = this.timeToString(this.workReport.from_time);
    this.workReport.to_time = this.timeToString(this.workReport.to_time);
    this.workReport.start_break_time1 = this.timeToString(this.workReport.start_break_time1);
    this.workReport.end_break_time1 = this.timeToString(this.workReport.end_break_time1);
    this.workReport.start_break_time2 = this.timeToString(this.workReport.start_break_time2);
    this.workReport.end_break_time2 = this.timeToString(this.workReport.end_break_time2);
    this.workReport.start_travel_time1 = this.timeToString(this.workReport.start_travel_time1);
    this.workReport.end_travel_time1 = this.timeToString(this.workReport.end_travel_time1);
    this.workReport.start_travel_time2 = this.timeToString(this.workReport.start_travel_time2);
    this.workReport.end_travel_time2 = this.timeToString(this.workReport.end_travel_time2);

    this.isWorkReportDeleteable = (
      this.workReport.from_time == '00:00' && this.workReport.to_time == '00:00' &&
      this.workReport.start_break_time1 == '00:00' && this.workReport.end_break_time1 == '00:00' &&
      this.workReport.start_break_time2 == '00:00' && this.workReport.end_break_time2 == '00:00'
    );

    loading.dismiss();
  }

  private timeToString(time) {
    if (typeof time === 'undefined')
      return '00:00';

    let seconds = Math.round(time * 3600 * 1000);
    let d = new Date(seconds);
    d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000);

    let hour = this.zfill(d.getHours(), 2);
    let minute = this.zfill(d.getMinutes(), 2);

    return this.zfill(`${hour}:${minute}`, 2);
  }

  private zfill(num, size) {
    let s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
  }

  validate() {
    this.validation.init();

    // Date must be single
    // if (this.doesDuplicatesExist(this.workReports, this.workReport)) {
    //   this.validation.addError('Es gibt bereits einen Arbeitsbericht an diesem Tag, Arbeitsbericht konnte nicht erstellt werden.');
    // }

    // From- / to- times
    console.log(this.workReport.to_time);
    if (this.workReport.from_time > this.workReport.to_time && this.workReport.to_time != '00:00')
      this.validation.addError("Die Startzeit (Arbeitszeit) kann nicht nach der Endzeit liegen.");
    if (this.workReport.start_break_time1 > this.workReport.end_break_time1)
      this.validation.addError("Die Startzeit (Pause 1) kann nicht nach der Endzeit liegen.");
    if (this.workReport.start_break_time2 > this.workReport.end_break_time2)
      this.validation.addError("Die Startzeit (Pause 2) kann nicht nach der Endzeit liegen.");
    if (this.workReport.start_travel_time1 > this.workReport.end_travel_time1)
      this.validation.addError("Die Startzeit (Reise 1) kann nicht nach der Endzeit liegen.");
    if (this.workReport.start_travel_time2 > this.workReport.end_travel_time2)
      this.validation.addError("Die Startzeit (Reise 2) kann nicht nach der Endzeit liegen.");
  }

  /*
  private doesDuplicatesExist(workReports: any, workReport: any) {
    for (let existingWorkReport of workReports) {
      if (workReport.date_work == existingWorkReport.date_work && workReport.name != existingWorkReport.name) {
        return true;
      }
    }
    return false;
  }
  */

  async save() {
    this.workReportName = null;

    this.validate();

    if (this.validation.isValid) {
      let loading = this.loadingCtrl.create({content: "Arbeitsbericht wird gespeichert, bitte warten ..."});
      loading.present();
      this.workReportName = await this.workReportProvider.save(this.workReport);
      loading.dismiss();

      if (!this.workReportName) {
        this.toast.error('Arbeitsbericht konnte nicht gespeichert werden, es ist ein Fehler aufgetreten.');
      }
    } else {
      this.validation.showMessages();
    }
  }

  async saveAndGoBack() {
    await this.save();

    if (this.workReportName)
      this.navCtrl.pop();
  }

  async goToWorkReportEditPart(part: any) {
    await this.save();

    if (this.workReportName)
      this.navCtrl.push(WorkReportEditPartPage, {
        part: part,
        salesOrder: this.salesOrder,
        workReport: this.workReport
      });
  }

  async goToWorkReportScanPart(part: any) {

  }

  async presentDeleteConfirm() {
    const alert = await this.alertController.create({
      message: 'Wollen Sie den Arbeitsbericht wirklich löschen?',
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'OK',
          handler: () => {
            this.removeWorkReport();
          }
        }
      ]
    });

    await alert.present();
  }

  async removeWorkReport() {
    let loading = this.loadingCtrl.create({content: "Arbeitsbericht wird gelöscht, bitte warten ..."});
    loading.present();
    await this.workReportProvider.delete(this.workReport.name);
    loading.dismiss();

    this.navCtrl.pop();
  }

  async deleteWorkReport()
  {
    this.presentDeleteConfirm();
  }

}



// WEBPACK FOOTER //
// ./src/pages/work-report/work-report.ts